import { useLocalStorageValue } from '@react-hookz/web';
import { useMemo } from 'react';
import { HAS_ACTIVATED_BETA_FEATURES } from 'services/localStorer';

export const useHasActivatedBetaFeatures = () => {
  const [hasActivatedBetaFeatures, setHasActivatedBetaFeatures] = useLocalStorageValue<boolean>(
    HAS_ACTIVATED_BETA_FEATURES,
  );

  return useMemo(
    () => ({
      hasActivatedBetaFeatures,
      setHasActivatedBetaFeatures,
    }),
    [hasActivatedBetaFeatures, setHasActivatedBetaFeatures],
  );
};
